<template>
  <div
    class="sideSlider"
    :class="{ animate, initial }"
    ref="slider"
    @scroll="onScroll"
    v-if="categories.length > 0"
  >
    <div class="top_gradient gradient" :class="{ animate, initial }">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="32px"
        viewBox="0 -960 960 960"
        width="32px"
        fill="#0003"
        style="rotate:-90deg"
      >
        <path d="m304-82-56-57 343-343-343-343 56-57 400 400L304-82Z" />
      </svg>
    </div>
    <div
      v-for="(category, index) in [...categories, ...categories, ...categories]"
      :key="index"
      class="tabitem"
      :class="{
        isActive:
          highlightEnabled &&
          currentCategory &&
          currentCategory.id === category.id,
        animate
      }"
      @click="getCurrent(category.id, index, $event)"
    >
      <div
        class="inner"
        :class="{
          slider:
            highlightEnabled &&
            currentCategory &&
            currentCategory.id === category.id
        }"
      >
        <div class="categoryName sliderName">
          {{
            getTranslation(
              $store,
              "Category",
              "display_name",
              category.id,
              category.name
            )
          }}
        </div>
        <img :src="category.image" />
      </div>
    </div>
    <div class="bottom_gradient gradient" :class="{ animate, initial }">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="32px"
        viewBox="0 -960 960 960"
        width="32px"
        fill="#0003"
        style="rotate:90deg; margin-top: 48px;"
      >
        <path d="m304-82-56-57 343-343-343-343 56-57 400 400L304-82Z" />
      </svg>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { getTranslation } from "@/utils/helpers";

const ELEMENT_SIZE = 220;
const SLIDER_HEIGHT = 1050;
const SLIDER_SCROLL_FPS = 45;
const SLIDER_SCROLL_ANIMATION_DURATION_MS = 1200;

export default {
  props: {
    highlightEnabled: Boolean
  },
  computed: {
    ...mapGetters({
      categories: "CATEGORIES_FILTERED",
      currentCategory: "CURRENT_CATEGORY"
    })
  },
  mounted() {
    if (
      typeof this.currentCategory !== "undefined" &&
      this.currentCategory !== null &&
      this.currentCategory.id
    ) {
      let index = this.categories.findIndex(
        c => c.id === this.currentCategory.id
      );
      this.getCurrent(this.currentCategory.id, index);
    }
  },
  beforeDestroy() {
    if (this.intv) clearInterval(this.intv);
  },
  data() {
    return {
      activeSlide: 0,
      scrollTarget: 0,
      scrollSrc: 0,
      ignore_next_scroll: true,
      time: 0,
      intv: null,
      scrolled: false,
      animate: false,
      initial: true
    };
  },
  methods: {
    getTranslation,
    ...mapActions({
      logAudit: "LOG_AUDIT"
    }),
    easeInOutSmoother: function(t) {
      var ts = t * t,
        tc = ts * t;
      return 6 * tc * ts - 15 * ts * ts + 10 * tc;
    },
    progressScroll() {
      const t = this.time / SLIDER_SCROLL_ANIMATION_DURATION_MS;
      if (t <= 1.0) {
        let p = this.easeInOutSmoother(t);
        let real_p = p * (this.scrollTarget - this.scrollSrc) + this.scrollSrc;
        this.ignore_next_scroll = true;
        this.$refs["slider"].scrollTo({
          left: 0,
          top: real_p,
          behavior: "auto"
        });
      } else {
        clearInterval(this.intv);
        this.intv = null;
      }
      this.time += 1000 / SLIDER_SCROLL_FPS;
    },
    getCurrent(id, index, event) {
      // automated scrolling to center con be simplified, but scroll speed semms not to be adjustable?
      // if (event)
      //   event.target.scrollIntoView({
      //     behavior: "smooth",
      //     block: "center"
      //   });
      // else this.startAnimations();

      //Scroll to selected category either by event with smoothing or programmatically (event not set) without smoothing
      this.scrolled = true;

      const total_size = this.categories.length * ELEMENT_SIZE + 20; //20 is extra margin from active items
      let upper_half_clicked;
      let rect;
      let pos;
      if (event) {
        rect = this.$refs["slider"].getBoundingClientRect();
        pos = this.$refs["slider"].scrollTop;
        upper_half_clicked = event.pageY - rect.top < SLIDER_HEIGHT / 2;
      } else {
        rect = null;
        pos = 0;
        upper_half_clicked = true;
      }

      let new_pos;
      if (upper_half_clicked) {
        new_pos = total_size + (pos % total_size);
      } else {
        new_pos = pos % total_size;
      }
      let target_pos =
        (index % this.categories.length) * ELEMENT_SIZE -
        SLIDER_HEIGHT / 2 +
        110;
      while (Math.abs(target_pos - new_pos) >= total_size / 2) {
        if (target_pos - new_pos >= total_size / 2) target_pos -= total_size;
        if (new_pos - target_pos >= total_size / 2) target_pos += total_size;
      }
      this.ignore_next_scroll = true;
      this.$refs["slider"].scrollTo({
        left: 0,
        top: new_pos,
        behavior: "auto"
      });
      setTimeout(() => {
        this.scrollTarget = target_pos;
        this.scrollSrc = new_pos;
        this.time = 0;
        if (!this.intv) {
          this.intv = setInterval(
            this.progressScroll,
            1000 / SLIDER_SCROLL_FPS
          );
        } else {
          this.time = 100; //go mid animation when interupted while animating.
        }
      }, 0);
      if (!event) {
        this.startAnimations();
      }

      this.activeSlide = index;
      this.logAudit({
        category: "PAGE",
        event: "CHANGED_TAB",
        data: this.categories.find(item => item.id === id).name
      });
      if (event) {
        this.$emit("onCategoryChange", id, event);
      }
    },
    onScroll(event) {
      //infinite Scrolling
      if (!this.ignore_next_scroll) {
        //user made scroll, cancel animation!
        clearInterval(this.intv);
        this.intv = null;
      }
      this.ignore_next_scroll = false;
      const pos = event.target.scrollTop;
      const total_size = this.categories.length * ELEMENT_SIZE;
      const element = this.$refs["slider"];
      if (pos === 0 && element)
        element.scrollTo({
          left: 0,
          top: total_size + (pos % total_size),
          behavior: "auto"
        });
      if (pos > 2 * total_size && element)
        element.scrollTo({
          left: 0,
          top: total_size - (pos % total_size),
          behavior: "auto"
        });
    },
    startAnimations() {
      this.animate = true;
      setTimeout(() => {
        this.animate = false;
      }, 1500);
      setTimeout(() => {
        this.initial = false;
      }, 800);
    }
  },
  watch: {
    currentCategory(newVal) {
      if (!newVal) return;
      //this scrolls once initially when a category is set.
      if (!this.scrolled) {
        this.scrolled = true;
        setTimeout(() => {
          let index = this.categories.findIndex(c => c.id === newVal.id);
          console.log("watcher:" + newVal.id + " index:" + index);
          this.getCurrent(newVal.id, index, false);
        }, 0);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@keyframes sideSliderIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes innerSlideDown {
  0% {
    transform: translateY(-2000px);
  }
  100% {
    transform: translateY(0px);
  }
}

@keyframes innerSlideDownActive {
  0% {
    transform: translateY(-2000px) var(--component_SliderTabs_active_transform);
  }
  100% {
    transform: translateY(0px) var(--component_SliderTabs_active_transform);
  }
}

@keyframes gradientIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.sideSlider {
  margin: 0;
  padding: 0;
  height: 1050px;
  width: 220px;
  flex-shrink: 0;
  overflow: scroll;
  transform-origin: 50% 50%;
}

.sideSlider.initial {
  opacity: 0;
}

.animate.sideSlider {
  animation: sideSliderIn 0.6s forwards ease-in-out;
  animation-delay: 0.2s;
}

#sliderArrowUp {
  background-image: var(--component_SliderTabs_sliderArrowUp_background_img);
  width: 48px;
  height: 24px;
  margin: auto;
}

#sliderArrowDown {
  background-image: var(--component_SliderTabs_sliderArrowDown_background_img);
  width: 48px;
  height: 28px;
  margin: auto;
  margin-top: 50px;
}

.tabitem {
  margin-bottom: 20px;
  height: 200px;
  width: 200px;
  margin-left: 10px;
  transition: transform 0.5s ease;
  transform-origin: 50% 50%;
}

.animate.tabitem {
  animation: innerSlideDown 1.4s forwards ease-in-out;
}

.animate.tabitem.isActive {
  animation: innerSlideDownActive 1.4s forwards ease-in-out;
}

.tabitem.isActive {
  transform: var(--component_SliderTabs_active_transform);
  margin-top: 30px;
  margin-bottom: 30px;
}

.inner {
  background: var(--component_SliderTabs_inner_background);
  color: var(--component_SliderTabs_inner_color);
  font-family: var(--component_SliderTabs_inner_font-family);
  border: var(--component_SliderTabs_inner_border);
  border-radius: var(--component_SliderTabs_inner_border-radius);
  height: 100%;
  display: flex;
  justify-content: space-evenly;
  text-align: center;
  align-items: center;
  flex-flow: column nowrap;
  transform-origin: 50% 50%;
}

.inner img {
  width: 95%;
  margin-top: var(--component_SliderTabs_inner_img_margin-top);
}
.categoryName {
  letter-spacing: var(--app_letter-spacing_dense);
  color: inherit;

  text-transform: uppercase;
}

.animate.gradient {
  animation: gradientIn 0.4s forwards ease-in-out;
  animation-delay: 0.8s;
}

.gradient {
  position: absolute;
  pointer-events: none;
  width: 220px;
  height: 80px;
  z-index: 4;
  text-align: center;
}

.gradient.initial {
  opacity: 0;
}

.gradient img {
  display: block;
  margin: auto;
  z-index: 5;
}

.top_gradient {
  top: 18px;
  left: 20px;
  background: var(--component_SliderTabs_top_gradient_background);
}

.bottom_gradient {
  bottom: 18px;
  left: 20px;
  background: var(--component_SliderTabs_bottom_gradient_background);
  vertical-align: bottom;
}

.bottom_gradient img {
  margin-top: 50px;
}

.slider {
  background: var(--component_SliderTabs_slider_background);
  color: var(--component_SliderTabs_slider_color);
  box-shadow: var(--component_SliderTabs_slider_box-shadow);
  border: var(--component_SliderTabs_slider_border);
  border-radius: var(--component_SliderTabs_slider_border-radius);
}

.sliderName {
  font-size: var(--component_SliderTabs_sliderName_font-size);
  line-height: var(--component_SliderTabs_sliderName_line-height);
  text-transform: var(--component_SliderTabs_sliderName_text-transform);
  text-decoration: var(--component_SliderTabs_sliderName_text-decoration);
  transform: var(--component_SliderTabs_sliderName_transform);
}
</style>
